var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: [
        "parametric-sort",
        { "is-sort": _vm.type === _vm.sort.type },
        _vm.sortType,
      ],
      on: {
        click: function ($event) {
          return _vm.setSort()
        },
      },
    },
    [
      _c("div", {
        staticClass: "parametric-sort__name",
        domProps: { innerHTML: _vm._s(_vm.name) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "parametric-sort__arrows" }, [
        _c(
          "svg",
          {
            staticClass: "parametric-sort__arrow-top",
            attrs: { width: "7", height: "4", viewBox: "0 0 7 4" },
          },
          [
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M4.03453 0.253496C3.87226 0.0898395\n                    3.65801 1.00867e-07 3.42832 1.20946e-07C3.19921 1.40976e-07 2.9838 0.0898395 2.82268\n                    0.253496L0.167585 3.01277C-0.0558159 3.2388 -0.0558159 3.60445 0.167585 3.83048C0.390414\n                    4.05651 0.752084 4.05651 0.975484 3.83048L3.42832 1.27549L5.88173 3.83048C6.10513 4.05651\n                    6.46623 4.05651 6.68963 3.83048C6.91303 3.60445 6.91303 3.2388 6.68963 3.01277L4.03453\n                    0.253496Z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "parametric-sort__arrow-bottom",
            attrs: { width: "7", height: "4", viewBox: "0 0 7 4" },
          },
          [
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2.82338 3.7465C2.98565 3.91016 3.1999 4 3.42959\n                    4C3.6587 4 3.87411 3.91016 4.03523 3.7465L6.69033 0.987232C6.91373 0.761203 6.91373 0.395551\n                    6.69033 0.169522C6.4675 -0.0565073 6.10583 -0.0565073 5.88243 0.169522L3.42959 2.72451L0.976182\n                    0.169522C0.752781 -0.0565073 0.391684 -0.0565073 0.168283 0.169522C-0.0551177 0.395551 -0.0551177\n                    0.761203 0.168283 0.987232L2.82338 3.7465Z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }